var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCredits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M32 20c0 6.075-4.93 11-11.01 11S9.98 26.075 9.98 20c0-.099.033-.197.066-.263L8.96 20.821a.607.607 0 0 1-.394.164.607.607 0 0 1-.394-.164c-.23-.23-.23-.591 0-.788l2.004-2.003c.066-.066.132-.099.198-.131a.515.515 0 0 1 .525.065c.033.033.066.033.099.066l2.005 2.003c.23.23.23.59 0 .788a.607.607 0 0 1-.395.164.607.607 0 0 1-.394-.164l-1.085-1.084a.618.618 0 0 1 .066.263c0 5.45 4.437 9.884 9.893 9.884 5.455 0 9.892-4.433 9.892-9.884 0-5.45-4.437-9.884-9.892-9.884-2.695 0-5.193 1.051-7.066 2.988-.23.23-.592.23-.79 0-.23-.23-.23-.59 0-.788C15.338 10.182 18.132 9 21.123 9 27.07 9 32 13.925 32 20zm-11.01-5.943a.576.576 0 0 0-.559.558v1.182h-.263a2.355 2.355 0 0 0-2.366 2.364 2.355 2.355 0 0 0 2.366 2.364h1.644a1.248 1.248 0 1 1 0 2.496h-.033H18.82a.576.576 0 0 0-.559.558c0 .296.263.558.559.558h1.577v1.182c0 .296.263.559.56.559a.576.576 0 0 0 .558-.559v-1.182h.263a2.355 2.355 0 0 0 2.366-2.364 2.355 2.355 0 0 0-2.366-2.364h-1.643a1.248 1.248 0 1 1 0-2.496h2.925a.576.576 0 0 0 .558-.558.576.576 0 0 0-.558-.558h-1.512v-1.182c.033-.296-.23-.558-.559-.558z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredits);
export default __webpack_public_path__ + "static/media/credits.2f15866334eba1a41b50c89120876a80.svg";
export { ForwardRef as ReactComponent };